/**
 * @module deliveryNoteStatus
 * @description A list of deliveryNoteStatus
 */

export const deliveryNoteStatus = [
	'delivered',
	'returned',
	'cancelled',
] as const;
export type DeliveryNoteStatus = (typeof deliveryNoteStatus)[number];
